module.exports = __webpack_public_path__ + "static/media/create.26440940.svg";